import type {
  AcumuladosRequestColumn,
  AcumuladosTestRow,
} from './acumulados-table-view.component';

export function escapeAcumuladosCsvField(value: unknown): string {
  let s = '';
  if (typeof value === 'string') {
    s = value;
  } else if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    s = `${value}`;
  }
  if (!/[;"'\n\r]/.test(s)) return s;
  return `"${s.replaceAll('"', '""')}"`;
}

function columnTitle(col: AcumuladosRequestColumn): string {
  const parts = [col.entryDate, col.requisNr, col.extRequisNr ? `(${col.extRequisNr})` : ''];
  return parts.filter(Boolean).join(' ');
}

export function buildAcumuladosTableCsv(
  columns: readonly AcumuladosRequestColumn[],
  rows: readonly AcumuladosTestRow[]
): string {
  const delim = ';';
  const header = [
    escapeAcumuladosCsvField('Técnica'),
    escapeAcumuladosCsvField('Unidades'),
    ...columns.map((col) => escapeAcumuladosCsvField(columnTitle(col))),
  ];
  const lines = [header.join(delim)];

  for (const row of rows) {
    const cells = row.cells.map((cell) => escapeAcumuladosCsvField(cell.result ?? ''));
    lines.push([
      escapeAcumuladosCsvField(row.testName),
      escapeAcumuladosCsvField(row.units),
      ...cells,
    ].join(delim));
  }

  return lines.join('\r\n');
}

function filenameDate(value: string): string {
  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(String(value ?? '').trim());
  if (!match) {
    return String(value ?? '').replaceAll(/\D/g, '') || '00000000';
  }
  const [, day, month, year] = match;
  return `${day.padStart(2, '0')}${month.padStart(2, '0')}${year}`;
}

export function buildAcumuladosCsvFilename(
  patientHistory: string | null | undefined,
  columns: readonly AcumuladosRequestColumn[]
): string {
  const nhc = String(patientHistory ?? '').replaceAll(/[^\w-]/g, '_').slice(0, 32);
  const firstDate = filenameDate(columns[0]?.entryDate ?? '');
  const lastDate = filenameDate(columns.at(-1)?.entryDate ?? '');
  return `Tabla acumulados_${nhc}_${firstDate}_${lastDate}.csv`;
}
